import type { ComponentType } from "react";

import { useNavigate, useParams } from "@tanstack/react-router";
import { Flex } from "antd";

import { FormView, SubEntityLayout } from "#layouts";

import styles from "./Plan.module.scss";
import { planSubNavItems } from "./planSubNavItems";

export const PlanDetail = () => {
	const { planID } = useParams({ strict: false });
	const navigate = useNavigate();
	const isCreateMode = planID === "create";
	const FormViewWithSaved = FormView as unknown as ComponentType<any>;

	return (
		<Flex vertical flex={1} className={styles.detail}>
			{isCreateMode ? (
				<FormViewWithSaved
					entity="plan"
					mode="create"
					onSaved={(
						result: Record<string, unknown>,
						ctx: { mode: "create" | "edit" | "read" }
					) => {
						if (ctx.mode !== "create" || result?.id == null) return;
						void navigate({
							to: `/plan/${String(result.id)}/snapshot` as "/",
							replace: true,
						});
					}}
				/>
			) : (
				<SubEntityLayout
					parentScope={`plan-${planID}`}
					basePath={`/plan/${planID}`}
					subEntities={planSubNavItems}
				/>
			)}
		</Flex>
	);
};
